import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { AzureApiService } from '../../services/azure-api.service';
import { DtoSaveResult } from '../../shared/models/DtoSaveResult';
import {DtoPlannerSettingsUser} from "./models/DtoPlannerSettingsUser";
import {plainToClass} from "class-transformer";
import {DtoInactivityList} from "./models/DtoInactivityList";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {DtoInactivity} from "./models/DtoInactivity";
import {SharedService} from "../../shared/shared.service";
import {DtoAppointmentLabel} from "./models/DtoAppointmentLabel";
import {DtoAppointmentKindList} from "./models/DtoAppointmentKindList";
import {DtoAppointmentKind} from "./models/DtoAppointmentKind";
import {DtoAppointmentKindBaseItems} from "./models/DtoAppointmentKindBaseItems";
import {DtoAppointmentKindForCombi} from "./models/DtoAppointmentKindForCombi";

@Injectable()
export class SettingsPlannerService {
    private apiUrlUser: string;
    private apiUrlInactivity: string;
    private apiUrlAppointmentLabel: string;
    private apiUrlAppointmentKind: string;
    private dtoAppointmentKindBaseItems: DtoAppointmentKindBaseItems;

    constructor(private http: AzureApiService, private ss: SharedService) {
        this.apiUrlUser = 'user';
        this.apiUrlInactivity = 'inactivity';
        this.apiUrlAppointmentLabel = 'appointmentlabel';
        this.apiUrlAppointmentKind = 'appointmentkind';
    }

    public getPlannerSettingsGeneral = (): Observable<DtoPlannerSettingsUser> => {
        return this.http.get<DtoPlannerSettingsUser>(`${this.apiUrlUser}/planner/general`);
    };

    public savePlannerSettingsGeneral = (dtoObject: DtoPlannerSettingsUser): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(`${this.apiUrlUser}/planner/general`, dtoObject);
    };

    // Inactivity
    public getInactivities = (): Observable<DtoInactivityList[]> => {
        return this.http.get<DtoInactivityList[]>(`${this.apiUrlInactivity}`);
    };

    public getInactivityById = (id: number): Observable<DtoInactivity> => {
        return this.http.get<DtoInactivity>(`${this.apiUrlInactivity}/${id}`);
    };

    public saveInactivity = (dtoObject: DtoInactivity): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrlInactivity, dtoObject);
    };

    public deleteInactivityById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlInactivity}/${id}`);
    };

    public checkDateOverlap = (id: number, checkDate: Date): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlInactivity}/dateoverlap/${id}/${this.ss.formatDate(checkDate, 'yyyy-MM-dd')}/`);
    };

    // AppointmentLabel
    public getAppointmentLabels = (): Observable<DtoAppointmentLabel[]> => {
        return this.http.get<DtoAppointmentLabel[]>(`${this.apiUrlAppointmentLabel}`);
    };

    public getAppointmentLabelById = (id: number): Observable<DtoAppointmentLabel> => {
        return this.http.get<DtoAppointmentLabel>(`${this.apiUrlAppointmentLabel}/${id}`);
    };

    public saveAppointmentLabel = (dtoObject: DtoAppointmentLabel): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrlAppointmentLabel, dtoObject);
    };

    public deleteAppoinmentLabelById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlAppointmentLabel}/${id}`);
    };

    public getAppoinmentLabelNextIndex = (): Observable<number> => {
        return this.http.get<number>(`${this.apiUrlAppointmentLabel}/nextindex`);
    };

    public checkAppoinmentLabelIndexAvailable = (id: number, index: number): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlAppointmentLabel}/indexavailable/${id}/${index}`);
    };

    // AppointmentKind
    public getAppointmentKinds = (): Observable<DtoAppointmentKindList[]> => {
        return this.http.get<DtoAppointmentKindList[]>(`${this.apiUrlAppointmentKind}`);
    };

    public getAppointmentKindById = (id: number): Observable<DtoAppointmentKind> => {
        return this.http.get<DtoAppointmentKind>(`${this.apiUrlAppointmentKind}/${id}`);
    };

    public saveAppointmentKind = (dtoObject: DtoAppointmentKind): Observable<DtoSaveResult> => {
        return this.http.post<DtoSaveResult>(this.apiUrlAppointmentKind, dtoObject);
    };

    public deleteAppoinmentKindById = (id: number): Observable<DtoDeleteResult> => {
        return this.http.delete<DtoDeleteResult>(`${this.apiUrlAppointmentKind}/${id}`);
    };

    public getAppoinmentKindNextIndex = (): Observable<number> => {
        return this.http.get<number>(`${this.apiUrlAppointmentKind}/nextindex`);
    };

    public checkAppoinmentKindIndexAvailable = (id: number, index: number): Observable<boolean> => {
        return this.http.get<boolean>(`${this.apiUrlAppointmentKind}/indexavailable/${id}/${index}`);
    };

    public getAppointmentKindsForCombi = (): Observable<DtoAppointmentKindForCombi[]> => {
        return this.http.get<DtoAppointmentKindForCombi[]>(`${this.apiUrlAppointmentKind}/forcombi`);
    };

    public getAppointmentKindBaseItems = (refresh: boolean): Observable<DtoAppointmentKindBaseItems> => {
        if (!this.dtoAppointmentKindBaseItems || refresh) {
            this.http.get<DtoAppointmentKindBaseItems>(`${this.apiUrlAppointmentKind}/baseitems`)
                .subscribe(response => this.dtoAppointmentKindBaseItems = response);
            return Observable.create(observer => {
                observer.next(this.dtoAppointmentKindBaseItems);
                observer.complete();
            });
        } else {
            return Observable.create(observer => {
                observer.next(this.dtoAppointmentKindBaseItems);
                observer.complete();
            });
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/settings-planner.service.ts